// extracted by mini-css-extract-plugin
export default {"flex_container":"OfferStackContainer_flex_container__jqgEQ","flex_child":"OfferStackContainer_flex_child__8Fet8","table_container":"OfferStackContainer_table_container__AzufM"};